module.exports = __webpack_public_path__ + "static/media/pic1.1c86fd47.png";